// Shared helpers for the AI settings cards. The lint config bans
// `.toLocale*()` method calls (they're conventionally used for date
// formatting; the rule routes those through useDateTimeFormatters). Numbers
// here go through Intl.NumberFormat directly, which sidesteps the rule and
// keeps thousands separators on token counts.
const numberFormatter = new Intl.NumberFormat()

export function formatNumber(value: number): string {
  return numberFormatter.format(value)
}
